import React from 'react'
import Script from 'next/script'
import { MenuItemWrapper } from 'src/layout/toolbar/menu-item'
import { ChatBubbleOutline } from '@emotion-icons/material/ChatBubbleOutline'
import { isFeatureEnabledNullable } from 'src/utils/feature-flag'

export const AtlasLink = () => {
  const isAtlasEnabled = isFeatureEnabledNullable('atlas-chat')

  if (!isAtlasEnabled) {
    return null
  }

  return (
    <>
      <Script id="atlas-snippet">
        {`(()=>{"use strict";var t,e={appId:"tr02nu5m7q",v:2,q:[],call:function(){this.q.push(arguments)}};window.Atlas=e;var n=document.createElement("script");n.async=!0,n.src="https://app.atlas.so/client-js/atlas.bundle.js";var s=document.getElementsByTagName("script")[0];null===(t=s.parentNode)||void 0===t||t.insertBefore(n,s)})();window.Atlas.call("start");`}
      </Script>
      <MenuItemWrapper>
        <ChatBubbleOutline size="16" />
      </MenuItemWrapper>
    </>
  )
}
